var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-col',{staticClass:"text-center mt-2 d-none",class:{ 'd-block': _vm.msg.status },attrs:{"cols":"12"}},[_c('v-alert',{attrs:{"type":_vm.msg.type}},[_vm._v(" "+_vm._s(_vm.msg.message)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }